module.exports = __webpack_public_path__ + "static/media/burger5.bbc7bdcb.jpg";